'use client';

import React from 'react';
import {VideoContainer} from '@/components/ui/video/Video.styles';

export type VideoCaption = {
    src: string;
    srcLang: string;
    label: string;
    kind?: 'captions' | 'subtitles' | 'descriptions';
    default?: boolean;
};

type VideoProps = {
    src: string;
    controls?: boolean;
    posterImage?: string;
    fillViewport?: boolean;
    height?: string;
    title?: string;
    usePosterImage?: boolean;
    autoPlay?: boolean;
    captions?: VideoCaption[];
};

export default function Video({ src, controls = false, posterImage, fillViewport = true, height, title, usePosterImage = false, autoPlay = true, captions = [] }: VideoProps) {
  return (
    <VideoContainer fillViewport={fillViewport} height={height}>
      <video
        style={{
          width: '100%',
          height: '100%',
          display: 'block',
          objectFit: 'cover',
        }}
        controls={controls}
        preload={autoPlay ? 'auto' : 'metadata'}
        autoPlay={autoPlay}
        playsInline
        muted
        loop
        {...usePosterImage && posterImage ? { poster: posterImage } : {}}
        {...(title ? { title } : {})}
      >
        <source src={src} type='video/mp4' />
        <source src={src} type='video/webm' />
        {captions.map((c) => (
          <track
            key={`${c.srcLang}-${c.kind ?? 'captions'}`}
            src={c.src}
            srcLang={c.srcLang}
            label={c.label}
            kind={c.kind ?? 'captions'}
            default={c.default}
          />
        ))}
          Your browser does not support the video tag.
      </video>
    </VideoContainer>
  );
}
